module.exports = __webpack_public_path__ + "static/img/djkx4.c27a4a1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx4.jpeg
// module id = bKAz
// module chunks = 1